module.exports = __webpack_public_path__ + "img/commit.42444145.svg";